// extracted by mini-css-extract-plugin
module.exports = {"promotion":"dd31006766--promotion--ImWSf","error":"dd31006766--error--Glfqb"};